// 海外区域编码
export var ABROAD_CODES = ['990000', '990100'];
